// extracted by mini-css-extract-plugin
export default {"root":"StudyProgress_root__+K6Z8","label":"StudyProgress_label__wmE1k"};